import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, interval, timer } from 'rxjs';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { IReportInvoiceAging } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-invoice-aging',
  templateUrl: './invoice-aging.component.html',
  styleUrl: './invoice-aging.component.scss'
})
export class InvoiceAgingComponent implements OnInit, OnDestroy{
  private subscriptions = new Subscription();
  reportAgingData: IReportInvoiceAging[] = [];
  parkerAging: number[] = [];
  companyAging: number[] = [];
  totalAging: number[] = [];
  chartTimer: any;


  constructor(public _appGeneralState: AppGeneralStateService,
              private _dataService: DataService
  ) {
    this.getInvoiceAgingData();
  }
  ngOnInit(): void {

    this._appGeneralState.lotNumberSubject.subscribe({
      next: (v) => this.getInvoiceAgingData(),
    });

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }


  getInvoiceAgingData():void{
    const lotNumber = this._appGeneralState.currentLotNumber;

    this.parkerAging = [];
    this.companyAging = [];
    this.totalAging = [];

    

    this.subscriptions = this._dataService.getReportInvoiceAging(lotNumber).subscribe(
      res => {
        this.reportAgingData = res
      },
      (err:any) => {
      },
      () => {
        
        this.segmentAgingData();

        this.chartTimer = interval(500).subscribe(x => {
          this._appGeneralState.PublishInvoiceAgingData(this.reportAgingData);
          this.chartTimer.unsubscribe();
        });
       
      }
    ) 
  }

  segmentAgingData():void{
    let ii = 0;

   //Totals
    
    this.totalAging.push(this.reportAgingData.find(data => data.agingCategory == '0' && data.parkerPayType == 'T').quantity);
    this.totalAging.push(this.reportAgingData.find(data => data.agingCategory == '0' && data.parkerPayType == 'T').amount);

    this.totalAging.push(this.reportAgingData.find(data => data.agingCategory == '1' && data.parkerPayType == 'T').quantity);
    this.totalAging.push(this.reportAgingData.find(data => data.agingCategory == '1' && data.parkerPayType == 'T').amount);

    this.totalAging.push(this.reportAgingData.find(data => data.agingCategory == '2' && data.parkerPayType == 'T').quantity);
    this.totalAging.push(this.reportAgingData.find(data => data.agingCategory == '2' && data.parkerPayType == 'T').amount);

    this.totalAging.push(this.reportAgingData.find(data => data.agingCategory == '3' && data.parkerPayType == 'T').quantity);
    this.totalAging.push(this.reportAgingData.find(data => data.agingCategory == '3' && data.parkerPayType == 'T').amount);

    this.totalAging.push(this.reportAgingData.find(data => data.agingCategory == '4' && data.parkerPayType == 'T').quantity);
    this.totalAging.push(this.reportAgingData.find(data => data.agingCategory == '4' && data.parkerPayType == 'T').amount);

    let grandTotalQuantity: number =0;
    let grandTotalAmount: number = 0;

   
      grandTotalQuantity = this.totalAging[0] + this.totalAging[2] + this.totalAging[4] + this.totalAging[6] + this.totalAging[8];
      grandTotalAmount = this.totalAging[1] + this.totalAging[3] + this.totalAging[5] + this.totalAging[7] + this.totalAging[9];;
    

    this.totalAging.push(grandTotalQuantity);
    this.totalAging.push(grandTotalAmount);

    //Parkers

    this.parkerAging.push(this.reportAgingData.find(data => data.agingCategory == '0' && data.parkerPayType == 'P').quantity);
    this.parkerAging.push(this.reportAgingData.find(data => data.agingCategory == '0' && data.parkerPayType == 'P').amount);

    this.parkerAging.push(this.reportAgingData.find(data => data.agingCategory == '1' && data.parkerPayType == 'P').quantity);
    this.parkerAging.push(this.reportAgingData.find(data => data.agingCategory == '1' && data.parkerPayType == 'P').amount);

    this.parkerAging.push(this.reportAgingData.find(data => data.agingCategory == '2' && data.parkerPayType == 'P').quantity);
    this.parkerAging.push(this.reportAgingData.find(data => data.agingCategory == '2' && data.parkerPayType == 'P').amount);

    this.parkerAging.push(this.reportAgingData.find(data => data.agingCategory == '3' && data.parkerPayType == 'P').quantity);
    this.parkerAging.push(this.reportAgingData.find(data => data.agingCategory == '3' && data.parkerPayType == 'P').amount);

    this.parkerAging.push(this.reportAgingData.find(data => data.agingCategory == '4' && data.parkerPayType == 'P').quantity);
    this.parkerAging.push(this.reportAgingData.find(data => data.agingCategory == '4' && data.parkerPayType == 'P').amount);

    grandTotalQuantity =0;
    grandTotalAmount = 0;

   
      grandTotalQuantity = this.parkerAging[0] + this.parkerAging[2] + this.parkerAging[4] + this.parkerAging[6] + this.parkerAging[8];
      grandTotalAmount = this.parkerAging[1] + this.parkerAging[3] + this.parkerAging[5] + this.parkerAging[7] + this.parkerAging[9];;
    

    this.parkerAging.push(grandTotalQuantity);
    this.parkerAging.push(grandTotalAmount);



    //Companies


    this.companyAging.push(this.reportAgingData.find(data => data.agingCategory == '0' && data.parkerPayType == 'C').quantity);
    this.companyAging.push(this.reportAgingData.find(data => data.agingCategory == '0' && data.parkerPayType == 'C').amount);

    this.companyAging.push(this.reportAgingData.find(data => data.agingCategory == '1' && data.parkerPayType == 'C').quantity);
    this.companyAging.push(this.reportAgingData.find(data => data.agingCategory == '1' && data.parkerPayType == 'C').amount);

    this.companyAging.push(this.reportAgingData.find(data => data.agingCategory == '2' && data.parkerPayType == 'C').quantity);
    this.companyAging.push(this.reportAgingData.find(data => data.agingCategory == '2' && data.parkerPayType == 'C').amount);

    this.companyAging.push(this.reportAgingData.find(data => data.agingCategory == '3' && data.parkerPayType == 'C').quantity);
    this.companyAging.push(this.reportAgingData.find(data => data.agingCategory == '3' && data.parkerPayType == 'C').amount);

    this.companyAging.push(this.reportAgingData.find(data => data.agingCategory == '4' && data.parkerPayType == 'C').quantity);
    this.companyAging.push(this.reportAgingData.find(data => data.agingCategory == '4' && data.parkerPayType == 'C').amount);

    grandTotalQuantity =0;
    grandTotalAmount = 0;

   
      grandTotalQuantity = this.companyAging[0] + this.companyAging[2] + this.companyAging[4] + this.companyAging[6] + this.companyAging[8];
      grandTotalAmount = this.companyAging[1] + this.companyAging[3] + this.companyAging[5] + this.companyAging[7] + this.companyAging[9];;
    

    this.companyAging.push(grandTotalQuantity);
    this.companyAging.push(grandTotalAmount);
      
    

  }


}
